//region :: Imports ::
import {createRef, ReactElement, RefObject} from 'react';
import {Messages} from 'primereact/messages';
import MComponent from '../Component';

//endregion

/** */
export type MMessageSeverity = 'success' | 'warn' | 'info' | 'error';

/** */
type Props = {
    onMessageClose?: () => void;
}

/** */
class MMessageBar extends MComponent<Props> {

    private readonly m_messageRef: RefObject<Messages>;

    /** */
    constructor(props: Props) {
        super(props);
        this.m_messageRef = createRef<Messages>();
    }

    /** */
    public show(text: string, severity: MMessageSeverity, sticky?: boolean, closable?: boolean, timeout?: number): void {

        this.m_messageRef.current!.replace([{

            summary: text,
            severity: severity,
            sticky: sticky,
            closable: closable,
            life: timeout

        }]);

    }

    /** */
    public success(text: string, sticky?: boolean, closable?: boolean): void {
        this.show(text, 'success', sticky, closable);
    }

    /** */
    public info(text: string, sticky?: boolean, closable?: boolean): void {
        this.show(text, 'info', sticky, closable);
    }

    /** */
    public warning(text: string, sticky?: boolean, closable?: boolean): void {
        this.show(text, 'warn', sticky, closable);
    }

    /** */
    public error(text: string): void {
        this.show(text, 'error', true, false);
    }

    /** */
    public close(): void {
        this.m_messageRef.current!.clear();
    }

    /** */
    public render(): ReactElement {

        return (
            <Messages onRemove={this.props.onMessageClose}
                      ref={this.m_messageRef}/>
        );

    }

}

export default MMessageBar;
